    <!--begin::Main-->
    <ngx-spinner class="custom-spinner"
    bdColor="rgba(255,255,255,1)"
      size="medium"
      color="#fff"
      type="ball-atom"
      [fullScreen]="true"
    >
    <span class="loader">
        <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
    </ngx-spinner>
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">

            <!--begin::Toolbar-->
            <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                    <!--begin::Page title-->
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <!--begin::Title-->
                     <div class="d-flex align-items-center">
                        <h1 class="page-heading"><svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_651_309)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3028 5.08326C31.7505 5.08326 31.3028 5.53097 31.3028 6.08326V17.5453H27.3636V0.999999C27.3636 0.447714 26.9158 0 26.3636 0H23.9696C23.4173 0 22.9696 0.447715 22.9696 1V17.5453H19.0304V11.5537C19.0304 11.0014 18.5827 10.5537 18.0304 10.5537H15.6364C15.0842 10.5537 14.6364 11.0014 14.6364 11.5537V17.5453H10.6913V8.07453C10.6913 7.52224 10.2436 7.07453 9.69133 7.07453H7.29738C6.74509 7.07453 6.29738 7.52224 6.29738 8.07453V17.5453H4V19H38V17.5453H35.7085V6.08326C35.7085 5.53097 35.2608 5.08326 34.7085 5.08326H32.3028Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_651_309" x="0" y="0" width="42" height="27" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_651_309"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_651_309" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            
                            
                            Evaluation
                        </h1>
                            <!--begin::Menu-->
                     </div>
                        <!--end::Title-->
                        <!--begin::Breadcrumb-->
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">
                                <a routerLink="/accueil" class="text-muted ">Accueil</a>
                              </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">Evaluation</li>

                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">Liste évaluations reçus</li>
                            <!--end::Item-->
                        </ul>
                        <!--end::Breadcrumb-->
                    </div>
                    <!--end::Page title-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Toolbar container-->
            </div>
            <!--end::Toolbar-->
            <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card">
                        <!--begin::Card header-->
                        <form [formGroup]="searchForm">
                      <div class="card-body tools">
                       <div class="title mb-10">
                        <h4>Recherche</h4>
                       </div>
                      <div class="container">
                        <div class="row mb-3">
                            <div class="col-lg-3">
                                            
                                <input type="text" formControlName="consultant" id="Nom" class="form-control form-control-solid mb-3" placeholder="Nom consultant">
                                
                            </div>
                            <div class="col-lg-3">
                               
                                <ng-select formControlName="evaluation_type"  [notFoundText]="'Aucun élément trouvé'" [items]="type" bindLabel="name" class="mb-3"
                                bindValue="id" [placeholder]="'Type'"  autoComplete>
                              </ng-select>       
                            </div>
                            <div class="col-lg-3">
                                <ng-select formControlName="state_pv"  [notFoundText]="'Aucun élément trouvé'" [items]="pv" bindLabel="name" class="mb-3"
                                bindValue="id" [placeholder]="'PV'"  autoComplete>
                              </ng-select>             
                        
                            </div>
                            
                        
                            <div class="col-lg-3 calenderDate">
                                <!-- <input type="date" formControlName="start_date" id="date" class="form-control form-control-solid mb-3" placeholder="Date début"> -->
                                <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de début" inputId="yearpicker" 
                        formControlName="start_date" class="form-control"
                       ></p-calendar>
    
                            </div>
                            <div class="col-lg-3 calenderDate">
                                <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de fin" inputId="yearpicker" 
                          formControlName="end_date" class="form-control"
                         ></p-calendar>
                                <!-- <input type="date" formControlName="end_date" id="date" class="form-control form-control-solid mb-3" placeholder="Date de fin "> -->
    
    
                            </div>
                            <div class="col-lg-3">
                            </div>
                            <div class="col-lg-6">
                                <div class="mb-3 search-btn d-flex justify-content-end">
                                    <div class="align-items-center recherche">
                                        <button type="button" class="me-5" (click)="searchevaluationreceive(1); startSearching = true">
                                            <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                    fill="white" />
                                            </svg>
                                            Rechercher</button>
                                    </div>
                                    <div class="resett-btn">
                                        <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                                            title="Réinitialiser">
                                            <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         
                           
                            
                        </div>
                    
                    
                     
    
                      </div>
                  
                      </div>
                    </form>
                    </div>

                </div>
                <!--end::Content container-->
            </div>
            <!--begin::Content-->

            <div id="kt_app_content" class="app-content flex-column-fluid mb-5">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card">
                     
                        <!--begin::Card header-->
                        <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section_title">
                                <h1 class="section-heading my-5">Liste des évaluations reçues</h1>
                               </div>
                            <!--begin::Tab nav-->
                            <!--end::Tab nav-->
                            <!--begin::Wrapper-->
                            <div class="filter-tools mt-10 mb-10">
                                <div class="filter">
                             </div>
                             <ul class="nav nav-pills me-5">
                                 <li class="nav-item m-0">
                                     <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3" data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                         <i class="ki-duotone ki-element-plus fs-1">
                                             <span class="path1"></span>
                                             <span class="path2"></span>
                                             <span class="path3"></span>
                                             <span class="path4"></span>
                                             <span class="path5"></span>
                                         </i>
                                     </a>
                                 </li>
                                 <li class="nav-item m-0">
                                     <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active" data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                         <i class="ki-duotone ki-row-horizontal fs-2">
                                             <span class="path1"></span>
                                             <span class="path2"></span>
                                         </i>
                                     </a>
                                 </li>
                             </ul>
                         </div>
                            <!--end::Wrapper-->
                        </div>
                      



                        <!--end::Card header-->
                        <!--begin::Card body-->
                        <div class="card-body pt-0">
                        <div class="tab-content for-web">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4" *ngFor="let eval of evaluationrecu">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            
                                            <div class="tools">
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                   
                                                    <img *ngIf="eval.candidate_image_url && eval.candidate_image_url!='avatar.png'" class="table-img" src="{{urlimage + eval.candidate_image_url}}" alt="" width="50px">
                                                    <img *ngIf="eval.candidate_image_url && eval.candidate_image_url=='avatar.png'" class="table-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt="" width="50px">
                                                    <img *ngIf="!eval.candidate_image_url || eval.candidate_image_url===undefined" class="table-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt="" width="50px">
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{{eval.evaluation.name}}   </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="content-card">
                                                    <!--begin::Stats-->
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Consultant :</span>{{eval.candidate_first_name}} {{eval.candidate_last_name}}</div>
                                                    </div>
    
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Date :</span> {{ eval.updated_at | date:'dd/MM/yyyy'}}</div>
                                                    </div>
    
                                                 
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                   
                                                  
                                                    <!--end::Stats-->
                                                </div>
                                         
                                              
                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
            
                                                    <span  *ngIf="eval.evaluation.type==1" class="hybrid">Annuelle</span>
                                                    <span  *ngIf="eval.evaluation.type==2" class="remote">Suivi</span>
                                                </div>
                                                <div class="plus cursor-pointer">
                                                    <a (click)="profilCompanyNavigation(eval.ideval_send)">Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                
                                    <div class="alert alert-warning text-center mt-5" role="alert"
                                    *ngIf="evaluationrecu && !evaluationrecu.length">
                            <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                            <span class="empty-list">
                                La liste est vide
                            </span>
                        </div>
                                 
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <div class="pt-3">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                                                <thead>
                                                    <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                        <th class="min-w-125px"><span>Photo</span></th>
                                                        <th class="min-w-125px"><span>Nom Consultant<i (click)="sortData('first_name')" class="fa-solid fa-sort cursor-pointer"></i></span></th>
                                                        
                                                        <th class="min-w-125px"><span>Type <i (click)="sortData('type')" class="fa-solid fa-sort cursor-pointer"></i></span></th>
                                                        <th class="min-w-125px"><span>PV</span> <i (click)="sortData('state_pv')" class="fa-solid fa-sort cursor-pointer"></i></th>
                                                        <th class="min-w-125px"><span>Date  <i (click)="sortData('updated_at')" class="fa-solid fa-sort cursor-pointer"></i></span></th>
                                                        
                                                        
                                                        <th class="min-w-90px"><span>Actions</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr *ngFor="let eval of evaluationrecu">
                                                        <td>
                                               
                                                         <img *ngIf="eval?.candidate_image_url && eval?.candidate_image_url !== 'avatar.png'" class="table-img" src="{{urlimage + eval?.candidate_image_url}}" alt="" width="50px">
                                                         <img *ngIf="!eval?.candidate_image_url || eval?.candidate_image_url === 'avatar.png'" class="table-img" src="/assets/media/icons/avatar.jpg" alt="" width="50px">
                                                         
                                                       
                                                        </td>
                                                  
                                                      
                                                        <td>
                                                           <span>{{eval?.candidate_first_name ? eval.candidate_first_name :'---'}} {{eval?.candidate_last_name ? eval?.candidate_last_name  :'---'}}</span>
                                                        </td>
                                                        <td>
                                                            <span class="hybrid" *ngIf="eval.evaluation.type==1">Annuelle</span>
                                                            <span class="remote" *ngIf="eval.evaluation.type==2">Suivi</span>
                                                            <span class="remote" *ngIf="!eval.evaluation.type">---</span>

                                                        
                                                        </td>
                                                        <td>
                                                           
                                                            <span  *ngIf="eval.state_pv==1">non remplie</span>
                                                            <span  *ngIf="eval.state_pv==2">encours</span>
                                                            <span  *ngIf="eval.state_pv==3">remplie</span>
                                                          </td>
                                                        <td>
                                                           <span>{{ eval.evaluation.updated_at | date:'dd/MM/yyyy'}}</span>
                                                        </td>
                      
                                                  

                                                      
                                                         <td>
                                                            <div class="btns">
                                                                <a (click)="profilCompanyNavigation(eval.evaluation_send_id)"  class="voir" style="cursor: pointer;">Voir</a>
                                                           
                                                            </div>
                                                         </td>
                                                    </tr>
                                               
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                        <div class="alert alert-warning text-center mt-5" role="alert"
                                        *ngIf="evaluationrecu && !evaluationrecu.length">
                                <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                <span class="empty-list">
                                    La liste est vide
                                </span>
                            </div>
                                    </div>
                                </div>
                            </div>
                            <!--end::Tab pane-->
                           
                        </div>

                        <div class="tab-content for-mobile">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4" *ngFor="let eval of evaluationrecu">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">

                                   
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img *ngIf="eval?.candidate_image_url && eval?.candidate_image_url !== 'avatar.png'" class="table-img" src="{{urlimage + eval?.candidate_image_url}}" alt="" width="50px">
                                                    <img *ngIf="!eval?.candidate_image_url || eval?.candidate_image_url === 'avatar.png'" class="table-img" src="/assets/media/icons/avatar.jpg" alt="" width="50px">
                                                    
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{{eval.evaluation.name}}   </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="content-card">
                                                    <!--begin::Stats-->
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Consultant :</span>{{eval.candidate_first_name}} {{eval.candidate_last_name}}</div>
                                                    </div>
    
                                                    <div class="py-3 px-4 mx-2">
                                                        <div class="badge-annee"> <span>Date :</span> {{ eval.evaluation.updated_at | date:'dd/MM/yyyy'}}</div>
                                                    </div>
    
                                                 
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                   
                                                  
                                                    <!--end::Stats-->
                                                </div>
                                         
                                              
                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
            
                                                    <span  *ngIf="eval.evaluation.type==1" class="hybrid">Annuelle</span>
                                                    <span  *ngIf="eval.evaluation.type==2" class="remote">Suivi</span>
                                            

                                                </div>
                                                <div class="plus">
                                                    <a routerLink="/evaluation/details-eval-rec/{{eval.evaluation_send_id}}">Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <div class="alert alert-warning text-center mt-5" role="alert"
                                    *ngIf="evaluationrecu && !evaluationrecu.length">
                            <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                            <span class="empty-list">
                                La liste est vide
                            </span>
                        </div>
                                   
                                 
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                         
                            <!--end::Tab pane-->
                           
                        </div>
                            <!--end::Table-->
                         
                 

                        </div>
                        <!--end::Card body-->
                     
                    </div>
                    <!--end::Card-->
                    <!--begin::Modals-->
                    <!--begin::Modal - Customers - Add-->
              
                    <!--end::Modal - Customers - Add-->
                    <!--begin::Modal - Adjust Balance-->
                
                    <!--end::Modal - New Card-->
                    <!--end::Modals-->
                    <div class="pagination" *ngIf="evaluationrecu && evaluationrecu.length">
                        <app-pagination [data]="evaluationrecu" [lengthData]="totalItems" (setPages)="getItems($event)" [currentPageList]="currentPage" [endexPageList]="endIndex"> </app-pagination>
                      </div>
                   
            
                </div>
                <!--end::Content container-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
    <!--end:::Main-->
    </div>

        <div class="modal fade" id="compte" tabindex="-1" aria-hidden="true">
            <!--begin::Modal dialog-->
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <!--begin::Modal content-->
                <div class="modal-content pt-5  pb-15" >
                    <!--begin::Modal header-->
                    <div class="modal-header" >
                        <!--begin::Modal title-->
                        <h2 class="fw-bold">Compte rendu</h2>
                        <!--end::Modal title-->
                        <!--begin::Close-->
                        <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
                            <i class="ki-duotone ki-cross fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <!--begin::Modal body-->
                    <div class="modal-body  mx-5 mx-xl-15 my-7" [formGroup]="formPV">
                        <h4 class="mb-5">Votre compte rendu</h4>
                        <textarea name="compte" id="rendu" style="height:150px" class="form-control compte-rendu" formControlName="report" ></textarea>
                      
                        
                   
                    </div>
                    <div class="card-footer text-center">
                        <div class="actions">
                            <a (click)="closeModal()" class="annuler" data-bs-dismiss="modal" aria-label="Close" style="cursor: pointer;">Annuler</a>
 
                            <a (click)="createcompterendu()" data-bs-dismiss="modal" aria-label="Close" class="confirmer" style="cursor: pointer;">Confirmer</a>
                        </div>
                    </div>
                    <!--end::Modal body-->
                </div>
                <!--end::Modal content-->
            </div>
            <!--end::Modal dialog-->
        </div>

        <div class="modal fade" id="signe" tabindex="-1" aria-hidden="true">
            <!--begin::Modal dialog-->
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <!--begin::Modal content-->
                <div class="modal-content pt-5  pb-15">
                    <!--begin::Modal header-->
                    <div class="modal-header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bold">Signer</h2>
                        <!--end::Modal title-->
                        <!--begin::Close-->
                        <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
                            <i class="ki-duotone ki-cross fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <!--begin::Modal body-->
                    <div class="modal-body  mx-5 mx-xl-15 my-7">
                        <h4 class="mb-5">Votre signature</h4>
                        <div class="custom-signature-pad">
                            <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)"
                                (onDrawComplete)="drawComplete()"></signature-pad>
                        </div>
                    </div>
                 
    
                    <div class="card-footer text-center">
                        <div class="actions">
                            <a href="#" class="annuler" data-bs-dismiss="modal" aria-label="Close">Annuler</a>
                            <a (click)=sendSignature()  class="confirmer">Confirmer</a>
                        </div>
                    </div>
                    <!--end::Modal body-->
                </div>
                <!--end::Modal content-->
            </div>
            <!--end::Modal dialog-->
        </div>